import React from 'react';
import styles from './StatsBlock.module.scss';
import { useTranslations } from 'next-intl';

export function StatsBlock() {
  const t = useTranslations('stats');
  return (
    <section className={styles.root} >
      <div className="gutter-row" >
        <h3>500K+</h3>
        <h4>{t('users')}</h4>
      </div>
      <div className="gutter-row" >
        <h3>5+</h3>
        <h4>{t('extensions')}</h4>
      </div>
      <div className="gutter-row">
        <h3>4.8★</h3>
        <h4>{t('avg_rating')}</h4>
      </div>
      <div className="gutter-row" >
        <h3>24/7</h3>
        <h4>{t('support')}</h4>
      </div>
    </section>
  );
}





